import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Image,
  Input,
  Row,
  Select,
  Typography,
  Upload,
} from "antd";
import React, { useEffect, useState } from "react";
import { GiCctvCamera, GiHouse } from "react-icons/gi";
import Scrollbars from "react-custom-scrollbars";
import { PlusOutlined } from "@ant-design/icons";
import Country from "country-data";
import moment from "moment";

import OfflineAutocomplete from "../../../../../components/autocomplete/Offline";
import { useLanguage } from "../../../../../hooks/useLanguage";
import { useDispatch } from "react-redux";
import { PostAPI } from "../../../../../redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ENV from "../../../../../config/env";
import { useParams } from "react-router-dom";
import { useMemo } from "react";
import { useFetch } from "../../../../../hooks/useFetch";

const { ImageUrl } = ENV;
const imgUri = ImageUrl || "/images/";
export default () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const [form] = Form.useForm();
  const [, getLan] = useLanguage();

  const url = useMemo(() => {
    return !!id && `api/v1/watchlist/detail/${id}`;
  }, [id]);

  const [editData] = useFetch(url);
  console.log();

  const [model, setModel] = useState({
    name: "",
    notes: "",
    pictures: [],
    old_picts: [],
    dob: null,
    gender: "male",
    nationality: Country.countries["IDN"],
    passport_number: "",
  });

  const handleSave = async (value) => {
    const newModel = { ...model, ...value };
    const { pictures, nationality, dob, ...rest } = newModel;
    const f = new FormData();
    f.append(
      "body",
      JSON.stringify({
        ...rest,
        nationality: nationality.alpha3,
        dob: dob.format("DD-MMM-YYYY"),
      })
    );
    for (let iii = 0; iii < pictures.length; iii++) {
      const p = pictures[iii];
      f.append("picts", p);
    }

    await dispatch(PostAPI({ data: f, url: "api/v1/watchlist" }));
    history.goBack();
  };

  useEffect(() => {
    if (!!id) {
      const { nationality, dob, ...rest } = editData;
      form.setFieldsValue({
        ...rest,
        nationality: Country.countries[nationality],
        dob: moment(dob, "DD-MMM-YYYY"),
      });
    } else {
      form.setFieldsValue({ ...model });
    }
  }, [id, editData]);
  return (
    // <Scrollbars>
    <div style={{ padding: 24 }}>
      <Form
        layout="vertical"
        form={form}
        initialValues={model}
        onFinish={handleSave}
        autoComplete="off"
      >
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              // width: "50%",
              rowGap: 8,
            }}
          >
            <Row gutter={[16,8]}>
              <Col span={24}>
                <Form.Item label={getLan("name")} name="name" required>
                  <Input size="large" autoFocus />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={12}>
                <Form.Item
                  label={getLan("passport_number")}
                  name="passport_number"
                  required
                >
                  <Input  size="large" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={12}>
                <Form.Item label={getLan("nationality")} name="nationality">
                  <OfflineAutocomplete
                    data={Country.countries.all}
                    onChange={(val) => setModel({ ...model, nationality: val })}
                    getKey={(val) => val.alpha2}
                    getValues={(val) => `${val.name}`}
                    getSelectedOptions={(val, opt) => val.alpha2 === opt.alpha2}
                    value={model.nationality}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={12}>
                <Form.Item label={getLan("gender")} name="gender">
                  <Select  size="large"
                    onChange={(val) => setModel({ ...model, gender: val })}
                  >
                    <Select.Option value="male">{getLan("male")}</Select.Option>
                    <Select.Option value="female">
                      {getLan("female")}
                    </Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={12}>
                <Form.Item label={getLan("dob")} name="dob">
                  <DatePicker
                   size="large"
                    format={"DD-MMM-YYYY"}
                    value={model.dob}
                    style={{ width: "100%" }}
                    onChange={(date) => setModel({ ...model, dob: date })}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label={getLan("notes")} name="notes" required>
                  <Input.TextArea rows={6} />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              //   width: "50%",
              rowGap: 8,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                gap: 8,
                rowGap: 8,
              }}
            >
              <Typography.Text>{getLan("picture_list")}</Typography.Text>
              <Divider style={{ marginBlock: 4 }} />
              {!!editData?.old_picts &&
                Array.isArray(editData?.old_picts) &&
                editData?.old_picts.map((pict, idx) => {
                  return (
                    <div key={`${pict}___${idx}`}>
                      <Image
                        src={imgUri + pict}
                        width={100}
                        height={100}
                        fallback={`data:image/png;base64,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`}
                      />
                    </div>
                  );
                })}
            </div>
            <Upload
              multiple
              accept="image/*"
              listType="picture-card"
              beforeUpload={(file, fList) => {
                setModel({ ...model, pictures: [...model.pictures, ...fList] });
                return false;
              }}
              onRemove={(file) => {
                const newPicts = model.pictures.filter(
                  (pict) => file.fileName !== pict.fileName
                );
                setModel({ ...model, pictures: [...newPicts] });
                return true;
              }}
            >
              <PlusOutlined />
              <div
                style={{
                  marginTop: 8,
                }}
              >
                Upload
              </div>
            </Upload>
          </div>
        </div>
        <Button size="large" className="mt-3" block type="primary" htmlType="submit">
          Save
        </Button>
      </Form>
    </div>

    // </Scrollbars>
  );
};
